import React from 'react'
import { styled } from '@mui/material/styles'
import { 
  HashRouter,
  Routes,
  Route 
} from 'react-router-dom'

import Header from '@views/header/Header'
import Login from '@views/login/Login'
import AdminRole from '@views/adminRole/AdminRole'
import AdminMonitoring from '@views/adminMonitoring/AdminMonitoring'
import Employee from '@views/employee/Employee'
import Board from '@views/board/Board'
import AdminEmployee from '@views/adminEmployee/AdminEmployee'
import AdminBoard from '@views/adminBoard/AdminBoard'
import NotFound from '@views/notFound/NotFound'
import ClientRoute from "./ClientRoute";
import AdminRoute from "./AdminRoute";

const Main = styled('main')({
  position: 'relative',
  maxWidth: 1480,
  margin: '64px auto',
  padding: '40px 20px'
})

const AppRoutes = ({
  token,
  userRoles
}) => {
  return (
    <HashRouter>
      { 
        token && <Header/>
      }
      <Main>
        <Routes>
          {
            token ? <>
              <Route path='/' element={
                <ClientRoute userRoles={userRoles}>
                  <Employee />
                </ClientRoute>} />
              <Route path='/board' element={
                <ClientRoute userRoles={userRoles}>
                  <Board />
                </ClientRoute>} />
              <Route path='/adminMonitoring' element={
                <AdminRoute userRoles={userRoles}>
                  <AdminMonitoring />
                </AdminRoute>} />
              <Route path='/adminRole' element={
                <AdminRoute userRoles={userRoles}>
                  <AdminRole />
                </AdminRoute>} />
              <Route path='/adminEmployee' element={
                <AdminRoute userRoles={userRoles}>
                  <AdminEmployee />
                </AdminRoute>} />
              <Route path='/adminBoard' element={
                <AdminRoute userRoles={userRoles}>
                  <AdminBoard />
                </AdminRoute>} />
              <Route path="*" element={<NotFound />}/>
            </> : <Route path="*" element={<Login />}/>
          }
        </Routes>
      </Main>
    </HashRouter>
  )
}

export default AppRoutes